<template>
  <div class="my-collection-container">
    <el-card>
      <div class="search-box">
        <el-autocomplete class="autocomplete" v-model="querySearch" :fetch-suggestions="querySearchAsync" placeholder="请输入内容..." @select="handleSelect" :debounce="600" :trigger-on-focus="false" select-when-unmatched highlight-first-item value-key="fileName">
          <i class="el-icon-search icon" slot="prefix">
          </i>
        </el-autocomplete>
        <!-- <el-divider class="hr"></el-divider> -->
        <el-tooltip class="search-btn" effect="dark" content="重置数据" placement="bottom">
          <i class="el-icon-refresh-right icon refresh-icon" @click="refleshData"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" placement="left-start">
          <div slot="content">
            <p>页面操作提示：</p>
            <p><span class="color-red">*</span>1. 文件搜索：默认根据文件名称和文件路径模糊搜索文件。</p>
            <p><span class="color-red">*</span>2. 取消收藏：移除收藏夹中对应的文件，支持重新收藏。</p>
            <p><span class="color-red">*</span>3. 文件下载：默认下载原文件（XPS默认文件编码：UTF-8）。</p>
            <p><span class="color-red">*</span>4. 打开文件位置：找到项目中文件存储的位置，注意：没有项目权限无法进入到项目。</p>
          </div>
          <i class="el-icon-info icon info-icon"></i>
        </el-tooltip>

      </div>
      <div class="favorite-table-container">
        <el-table :data="tableData" style="width: 100%;" :height="tableHeight" :highlight-current-row="true">
          <div slot="empty" class="empty-content empty-image">
            <p class="empty-text">收藏夹空空如也哦~</p>
          </div>
          <el-table-column label="文件名称" prop="fileName" show-overflow-tooltip min-width="240px" sortable>
            <template v-slot="{row}">
              <div class="file-content file-page-container">
                <img class="file-image" v-if="row.isImg" :src="row.filePath" fit="contain" @error="imgOnError($event,row.fid)" />
                <div v-else class="file-image file-icon" :class="`file-icon-${row.ext}`"></div>
                <span class="file-name">{{row.fileName}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="作者" prop="author" show-overflow-tooltip min-width="90px" sortable>
            <template v-slot="{row}">
              <span>{{row.author?row.author.realName:'未知用户'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="CDN地址" prop="filePath" show-overflow-tooltip min-width="400px" sortable>
            <template v-slot="{row}">
              <span title="复制" class="table-cdn" v-clipboard:copy="row.filePath" v-clipboard:success="onCopy">{{row.filePath}}</span>
            </template>
          </el-table-column>
          <el-table-column label="开始收藏时间" prop="createTime" width="150px" sortable>
            <template v-slot="{row}">
              {{row.createTime?formatTime(row.createTime):''}}
            </template>
          </el-table-column>
          <el-table-column label="最近收藏时间" prop="updateTime" width="150px" sortable>
            <template v-slot="{row}">
              {{row.updateTime?formatTime(row.updateTime):''}}
            </template>
          </el-table-column>
          <el-table-column align="center" fixed="right" min-width="200px">
            <template slot="header">
              <el-input v-model="search" size="mini" placeholder="输入文件名称搜索" />
            </template>
            <template v-slot="{row}">
              <el-button type="text" @click="downloadFile(row)">下载</el-button>
              <el-button type="text" @click="removeFavoriteFile(row.filePath)">取消收藏</el-button>
              <el-button type="text" @click="openFileDirection(row)">打开文件位置</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="find-container-pager" @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="pageConfig.pageNum" :page-sizes="[10, 50, 100, 200]" :page-size="pageConfig.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" :pager-count="5">
        </el-pagination>
      </div>

    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { myFilesApi } from '@/api/index';
import { getExt, isImg } from '@/common/utils/ext.js';
import { showLoading, hideLoading } from '@/plugins/loading';
import { downloadFile } from '@/common/utils/download.js';
export default {
  data () {
    return {
      findFileList: [], // 查询文件列表
      // 分页查询参数
      pageConfig: {
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      search: '',
      querySearch: '',
      errorImg: 'https://front-xps-cdn.xsyx.xyz/custom/xps/images/delete.png',
      errorId: '',
      tableHeight: '400px'
    }
  },
  computed: {
    tableData () {
      return this.findFileList.filter(data => !this.search || data.fileName.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  mounted () {
    this.getFavoriteFiles();
    this.$nextTick(() => {
      this.tableHeight = `${document.body.clientHeight && document.documentElement.clientHeight - 248}px`;
    })
    window.addEventListener('resize', () => {
      this.onWindowResize();
    });
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.onWindowResize();
    });
  },
  methods: {
    // 监听窗口变化
    onWindowResize () {
      this.$nextTick(() => {
        this.tableHeight = `${document.body.clientHeight && document.documentElement.clientHeight - 248}px`;
      })
    },
    // 获取收藏文件
    async getFavoriteFiles () {
      showLoading();
      const res = await myFilesApi.getFavoriteFiles({ querySearch: this.querySearch, ...this.pageConfig });
      if (res.code === 200) {
        if (res.data.length > 0) {
          res.data.forEach(item => {
            item.isImg = isImg(item.filePath);
            item.ext = getExt(item.filePath);
          })
        }
        this.findFileList = res.data;
        this.total = res.total;
      } else {
        this.$message.error(res.message);
      }
      hideLoading();
    },
    async querySearchAsync (queryString, cb) {
      await this.getFavoriteFiles();
      cb(this.findFileList);
    },
    handleSelect (item) {
      this.queryString = item;
      this.getFavoriteFiles();
    },
    // 重置数据
    refleshData () {
      this.querySearch = '';
      this.getFavoriteFiles();
    },
    // 下载文件对象
    async downloadFile (file) {
      downloadFile(file.filePath, file.fileName);
    },
    // 取消收藏文件
    async removeFavoriteFile (filePath) {
      this.$confirm('是否取消收藏该文件？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await myFilesApi.removeFavoriteFile({ filePath });
        if (res.code === 200) {
          this.getFavoriteFiles();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 跳转到指定目录
    openFileDirection (row) {
      let fPathArr = row.filePath.split('https://front-xps-cdn.xsyx.xyz');
      if (fPathArr.length <= 1) {
        fPathArr = row.filePath.split('https://uat-xps-cdn.xsyx.xyz')
      }
      const fPath = fPathArr[1];
      const path = fPath.substr(0, fPath.lastIndexOf('/') + 1);
      const name = fPath.substr(fPath.lastIndexOf('/') + 1);
      this.$router.push({ name: 'projectDetail', query: { path, name } })
    },
    //图片损毁时触发
    imgOnError (e, id) {
      let img = e.srcElement;
      img.title = '图片资源已失效';
      img.src = this.errorImg;
      if (this.errorId !== id) this.deleteExpiredFile(id);
      this.errorId = id;
      img.onerror = null; //防止闪图
    },
    // 删除失效文件
    async deleteExpiredFile (id) {
      await myFilesApi.deleteExpiredFile({ id })
    },
    // 当当前页数改变，触发事件
    handlePageChange (num) {
      this.pageConfig.pageNum = num;
      this.getExpiredFiles();
    },
    // 当页面显示数据总数改变，触发事件
    handleSizeChange (size) {
      this.pageConfig.pageSize = size;
      this.getExpiredFiles();
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 复制
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
  }
}
</script>

<style lang="scss">
.my-collection-container {
  .search-box {
    position: relative;
    .icon {
      margin-left: 5px;
      font-size: 24px;
      line-height: 48px;
      color: #c0c4cc;
      &.refresh-icon {
        position: absolute;
        right: 10px;
        top: 0;
        cursor: pointer;
        z-index: 100;
      }
      &.info-icon {
        position: absolute;
        right: 40px;
        top: 0;
        cursor: pointer;
        z-index: 100;
      }
    }
    .autocomplete {
      width: 100%;
      .el-input__inner {
        font-size: 24px;
        border: 0 !important;
        height: 48px;
        line-height: 48px;
        padding-left: 48px;
      }
    }
    .hr {
      margin: 12px 0;
    }
  }
  .favorite-table-container {
    position: relative;
    overflow: auto;
    height: calc(100% - 250px);
    .empty-content.empty-image {
      height: 400px;
      background-size: 60%;
      background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/favorite-4.png");
      background-repeat: no-repeat;
      background-position: center;
    }
    .empty-text {
      position: relative;
      top: 300px;
      font-weight: 500;
      color: #bcbcbc;
    }
    .file-content {
      display: flex;
      justify-content: left;
      align-items: center;
      .file-image {
        display: inline-block;
        margin-right: 20px;
        width: 40px;
        max-height: 40px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        &.file-icon {
          min-width: 40px;
          height: 40px;
          margin-bottom: 0;
        }
      }
    }
    .find-container-pager {
      margin-top: 15px;
      text-align: center;
    }
    .table-cdn {
      cursor: pointer;
      &:hover {
        color: #409eff;
      }
    }
  }
}
</style>